"use strict";
function $ff5963eb1fccf552$export$e08e3b67e392101e(...callbacks) {
  return (...args) => {
    for (let callback of callbacks) if (typeof callback === "function") callback(...args);
  };
}
exports.$ff5963eb1fccf552$export$e08e3b67e392101e = $ff5963eb1fccf552$export$e08e3b67e392101e;
